import I1 from '../img/i1.png'
import F1 from '../img/f1.png'
import C3 from '../img/bk1.png'
import B1 from '../img/b1.png'

export const heroData = [
    {
        id: 1,
        name: 'Icecream',
        desc: 'Chocolate & Vanilla',
        price: '95',
        imgSrs: I1
    },
    
    
    {
        id: 2,
        name: 'Strawberries',
        desc: 'Fresh Strawberries',
        price: '140',
        imgSrs: F1
    },
    {
        id: 3,
        name: 'Donut',
        desc: 'Pastry Donut',
        price: '70',
        imgSrs: C3
    },
    {
        id: 4,
        name: 'Burger',
        desc: 'Veg Maxican Burger',
        price: '110',
        imgSrs: B1
    },
]

export const categories = [
    {
        id: 1,
        name: "Maxican",
        urlParamName: "italian",
    },
    {
        id: 2,
        name: "Curry",
        urlParamName: "curry",
    },
    {
        id: 3,
        name: "Rice",
        urlParamName: "rice",
    },
    {
        id: 4,
        name: "Sweets",
        urlParamName: "sweet",
    },
    {
        id: 5,
        name: "Fruits",
        urlParamName: "fruits",
    },
    {
        id: 6,
        name: "Icecreams",
        urlParamName: "icecreams",
    },

    {
        id: 7,
        name: "Soft Drinks",
        urlParamName: "drinks",
    },
];

export const states = ['Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu', 'Jharkhand', 'Karnataka', 'Kashmir', 'Kerala', 'Ladakh', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttarakhand', 'Uttar Pradesh', 'West Bengal']